import { BaseApiService } from './BaseApiService'

/**
 * Voice API Service
 *
 * Handles API calls related to voice functionality,
 * including getting access tokens for voice calls
 */

export interface TwilioTokenResponse {
  token: string
}

export interface CallMetricsData {
  phoneNumber: string
  duration: number
  status: string
  startTime: Date
  endTime?: Date
}

export class VoiceApiService extends BaseApiService {
  /**
   * Get Twilio access token for voice calls
   */
  async getTwilioAccessToken(): Promise<TwilioTokenResponse> {
    return this.post<TwilioTokenResponse>('/twilio/token', {}, {
      requiresAuth: true,
    })
  }
}

// Singleton instance
export const voiceApiService = new VoiceApiService()
